import React, { useEffect, useState } from 'react';
import Checkbox from '../../../../Components/Base/Checkbox/Checkbox';
import { useAppContext } from '../../../../Services/AppContext';
import Loading, { LoadingSize } from '../../../../Components/Loading';
import useElectronicSignature from '../../Hooks/useElectronicSignature';
import ElectronicSignaturePasswordRequestModal from '../ElectronicSignaturePasswordRequest/ElectronicSignaturePasswordRequestModal';
import useMeta from '../../../Meta/Hooks/useMeta';

const ElectronicSignatureSetup: React.FC = () => {
	const { userData } = useAppContext();
	const {
		isQualifiedCertificateForElectronicSignatureUsed,
		isPasswordRequiredForElectronicSignatureUsed,
		isLoading,
	} = useElectronicSignature();
	const [checked, setChecked] = useState(false);
	const [usePassword, setUsePassword] = useState(false);
	const [isPasswordRequestOpen, setIsPasswordRequestOpen] = useState(false);
	const { createUserMeta } = useMeta();

	useEffect(() => {
		setChecked(isQualifiedCertificateForElectronicSignatureUsed);
	}, [isQualifiedCertificateForElectronicSignatureUsed]);

	useEffect(() => {
		setUsePassword(isPasswordRequiredForElectronicSignatureUsed);
	}, [isPasswordRequiredForElectronicSignatureUsed]);

	const handleChange = async (value: boolean) => {
		setChecked(value);
		await createUserMeta(
			userData.id,
			'useQualifiedCertificateForElectronicSignature',
			value,
		);
		await handleChangePasswordUse(false, false);
	};

	const handleVerifyPassword = async () => {
		setIsPasswordRequestOpen(false);
		await handleChangePasswordUse(false, false);
	};

	const handleChangePasswordUse = async (
		value: boolean,
		askForPassword: boolean,
	) => {
		if (askForPassword) {
			setIsPasswordRequestOpen(true);
			return;
		}
		setUsePassword(value);
		await createUserMeta(
			userData.id,
			'requirePasswordForElectronicSignature',
			value,
		);
	};

	if (isLoading) {
		return <Loading size={LoadingSize.SMALL} />;
	}

	return (
		<>
			<Checkbox
				tx='component.electronicSignatureSetup.checkbox'
				value={checked}
				onChange={handleChange}
			/>
			{checked && (
				<div className='mt-3'>
					<Checkbox
						tx='component.electronicSignatureSetup.passwordCheckbox'
						value={usePassword}
						onChange={(value: boolean) =>
							handleChangePasswordUse(value, usePassword)
						}
					/>
				</div>
			)}
			{isPasswordRequestOpen && (
				<ElectronicSignaturePasswordRequestModal
					isOpen
					onClose={() => setIsPasswordRequestOpen(false)}
					onVerify={handleVerifyPassword}
					submitButtonText='component.electronicSignatureSetup.turnOff'
				/>
			)}
		</>
	);
};

export default ElectronicSignatureSetup;
